import { Component, OnInit } from '@angular/core';
import { CarrierService } from 'app/services/carrier.service';
import { AuthWebService } from 'app/services/authweb.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CarrierAccountService } from 'app/services/carrier-account.service';
import { PopupService } from 'app/services/shared/popup.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { EnterConfirmationPopupComponent } from './enter-confirmation-popup/enter-confirmation-popup.component';

@Component({
  selector: 'app-delink-carrier-account',
  templateUrl: './delink-carrier-account.component.html',
  styleUrls: ['./delink-carrier-account.component.css']
})
export class DeLinkCarrierAccountComponent implements OnInit {

  isLoading: Boolean = false;
  message: string = 'Loading  carrier accounts, please wait...';
  carrierAccounts: any = [];
    userData: any;
    carrierCode: string;
  
  user: any = {};
  constructor(private carrierAccountService: CarrierAccountService, private carrierService: CarrierService, private authWebService: AuthWebService, private router: Router,
    private toaster: ToastrService, private showModal: PopupService, public dialogService: ConfirmDialogService) { 
      this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
    }

  ngOnInit() {
    this.userData = this.authWebService.userData;
    }

    GetAccounts() {
        this.carrierAccountService.GetLinkedCarrierAccounts(this.userData.User.ID).subscribe(result => {
            this.carrierAccounts = result;
        });
    }

    onSearch() {
        this.carrierAccountService.GetLinkedCarrierAccountsByCarrierCode(this.carrierCode).subscribe(result => {
            this.carrierAccounts = result;
            if (this.carrierAccounts == null || this.carrierAccounts.length < 1) {
                this.toaster.warning('No carrier account found using "' + this.carrierCode + '".');
            }
        });
    }

  enterConfirmation(legacy_carrier_code) {
    this.dialogService.confirmThis('Are you sure you want to delink ' + legacy_carrier_code + "?", () => {  
      this.carrierCode = legacy_carrier_code;
      this.onSearch();
    this.toaster.success('' + legacy_carrier_code + ' has been successfully de-linked.');
    this.confirm(legacy_carrier_code) 
    }, () =>  { 
      this.toaster.warning('Delinking Unsuccessful.'); 
      return;
    })
   

    //   this.dialogService.addDialog(EnterConfirmationPopupComponent, {
    //   title: 'Confirm Carrier Account De-Linking',
    //       message: 'Are you sure you want to delink ' + legacy_carrier_code + "?",
    //   comment: ``,
    //   confirmButtonText: 'Confirm',
    //   cancelButtonText: 'Cancel',
    //       account: legacy_carrier_code
    // }).subscribe((isConfirmed) => {
    //     if (isConfirmed) {
    //         this.carrierCode = legacy_carrier_code;
    //         this.onSearch();
    //       this.toaster.success('' + legacy_carrier_code + ' has been successfully de-linked.');
    //   } else {
    //     this.toaster.warning('An error occured, please try again.');
    //   }
    // });
  }
  confirm(otpInput) {
    this.carrierAccountService.CarrierAccountDelinkConfirmation(this.carrierCode).subscribe((result:any) => {
  if (result == "success") {

  }
  else {


      if (result == "invalid") {
          
      } else {
          this.toaster.warning(result);
      }
  }
});
  }
}
